// extracted by mini-css-extract-plugin
export default {"responselistmain":"ResponseList_responselistmain__j6I6j","responselisttablewrapper":"ResponseList_responselisttablewrapper__RiC9+"};